export default "__VITE_ASSET__22CnYZz2__"